exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-red {\n  height: 40px;\n  border-radius: 5px;\n  width: 6rem;\n  font-size: 1.2rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.btn-create {\n  background-color: transparent;\n  color: white;\n  outline: none;\n  border: none;\n  box-shadow: none; }\n\n.card-header {\n  background-color: #ced2ddc7; }\n\n.usblick {\n  color: #132d46; }\n\n.title-inputs {\n  background-color: #ced2ddc7;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/user/user-new/user-new.component.scss
// module id = ../../../../../src/app/admin/user/user-new/user-new.component.scss
// module chunks = user.module